<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50">
        <defs>
            <clipPath id="clip-Twitter">
                <rect width="50" height="50"/>
            </clipPath>
        </defs>
        <g id="Twitter" clip-path="url(#clip-Twitter)">
            <path id="Tracé_3531" data-name="Tracé 3531" d="M269.007,156.9a14.258,14.258,0,0,0,21.933-12.659,10.164,10.164,0,0,0,2.5-2.6,10,10,0,0,1-2.878.789,5.02,5.02,0,0,0,2.2-2.774,10.058,10.058,0,0,1-3.182,1.217,5.017,5.017,0,0,0-8.542,4.572,14.226,14.226,0,0,1-10.331-5.237,5.019,5.019,0,0,0,1.551,6.693,5,5,0,0,1-2.271-.628,5.02,5.02,0,0,0,4.021,4.98,5.018,5.018,0,0,1-2.263.084,5.014,5.014,0,0,0,4.682,3.482A10.081,10.081,0,0,1,269.007,156.9Z" transform="translate(-255.049 -124.478)" fill="none" :stroke="color" stroke-width="1.9"/>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconTwitterOutline',
    mixins: [Colorable],
};
</script>
